// extracted by mini-css-extract-plugin
export var md = "_2i-4";
export var semantic = "_2i-5";
export var sm = "_2i-3";
export var text = "_2i-6";
export var toggleInput = "_2i-0";
export var toggleSwitch = "_2i-1";
export var xs = "_2i-2";